export const SET_INITIAL_APP_STATE = 'SET_INITIAL_APP_STATE'
export const SET_ONLINE_BOOKING_INFO = 'SET_ONLINE_BOOKING_INFO'
export const UPDATE_APP_STATE = 'UPDATE_APP_STATE'
export const UPDATE_APP_CONFIGURATION = 'UPDATE_APP_CONFIGURATION'
export const SET_ENABLED_DIALOG_STATUS = 'SET_ENABLED_DIALOG_STATUS'
export const SET_DISABLED_DIALOG_STATUS = 'SET_DISABLED_DIALOG_STATUS'
export const SET_REVIEWS_ENABLED_DIALOG_STATUS = 'SET_REVIEWS_ENABLED_DIALOG_STATUS'
export const BUSINESS_HOURS = 'BUSINESS_HOURS'
export const CLOSE_GOOGLE_REVIEWS_DIALOG = 'CLOSE_GOOGLE_REVIEWS_DIALOG'
export const SET_GOOGLE_PLACE_ID = 'SET_GOOGLE_PLACE_ID'
export const SET_GOOGLE_REVIEWS_ERROR = 'SET_GOOGLE_REVIEWS_ERROR'
export const TOGGLE_NOTIFICATIONS_EXCLUSION_ERROR = 'TOGGLE_NOTIFICATIONS_EXCLUSION_ERROR'
